// Locations where Coastal Harvest Co products are available for purchase.
// Single source of truth for the "Where to Find Us" page and the About page,
// so the copy never drifts.

export interface PurchaseLocation {
  name: string;
  addressLine: string;
  cityStateZip: string;
}

export const LOCATIONS: readonly PurchaseLocation[] = [
  {
    name: 'Fort Salonga Market IGA',
    addressLine: '10 Fort Salonga Rd #15',
    cityStateZip: 'Fort Salonga, NY 11768',
  },
];

/** Locations we've announced but where products aren't on shelves yet. */
export const COMING_SOON_LOCATIONS: readonly PurchaseLocation[] = [
  {
    name: 'Long Island Welcome Center',
    addressLine: '5100 Long Island Expy, Eastbound between Exits 51 & 52',
    cityStateZip: 'Dix Hills, NY 11746',
  },
  {
    name: "Grace's Marketplace",
    addressLine: '81 Glen Cove Road',
    cityStateZip: 'Greenvale, NY 11548',
  },
];

/** Short blurb used wherever we point shoppers at current availability. */
export const MORE_LOCATIONS_NOTE = 'More locations coming soon!';

function mapsQuery(location: PurchaseLocation): string {
  return `${location.name}, ${location.addressLine}, ${location.cityStateZip}`;
}

/** Google Maps link for a location (official Maps URLs API — no key needed). */
export function mapsLinkUrl(location: PurchaseLocation): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapsQuery(location))}`;
}

/**
 * Keyless Google Maps iframe embed for a location. The `output=embed` variant
 * needs no API key; the production CSP allows it via frame-src (see
 * frontend/vite.config.ts). Swap to the Maps Embed API
 * (https://www.google.com/maps/embed/v1/place?key=...) if an official,
 * key-backed endpoint is ever preferred.
 */
export function mapsEmbedUrl(location: PurchaseLocation): string {
  return `https://www.google.com/maps?q=${encodeURIComponent(mapsQuery(location))}&output=embed`;
}
